import { createFileRoute, redirect } from "@tanstack/react-router"

import PermissionDeniedAlert from "@/components/common/Alerts/PermissionDeniedAlert"
import { PermissionActionType } from "@/constants/permissions"
import { invoicesSearchParamsSchema } from "@/screens/Accounting/subfeatures/Invoices/schemas"
import { payableApprovalsSearchParamsSchema } from "@/screens/Accounting/subfeatures/PayableApprovals/types/searchParams"
import { payFileSearchParamsSchema } from "@/screens/Accounting/subfeatures/PayFiles/types/searchParams"
import { useCurrentUserStore } from "@/stores/currentUserStore"

// The three tabs below declare their sort params as required-with-fallback, so `redirect` demands a
// `search` value. Parsing an empty object yields each tab's own documented defaults instead of
// restating them here, where they'd silently drift.
export const Route = createFileRoute("/app/accounting/")({
  beforeLoad: () => {
    const { currentUser } = useCurrentUserStore.getState()
    const permissions = currentUser?.permissions ?? []

    if (permissions.includes(PermissionActionType.GL_TRANSACTION_VIEW)) {
      throw redirect({ to: "/app/accounting/gl-transactions" })
    }

    if (
      permissions.includes(PermissionActionType.ACCOUNTS_PAYABLE_VIEW) ||
      permissions.includes(PermissionActionType.ACCOUNTS_PAYABLE_MAINTENANCE)
    ) {
      throw redirect({
        to: "/app/accounting/accounts-payable",
        search: invoicesSearchParamsSchema.parse({}),
      })
    }

    if (permissions.includes(PermissionActionType.PAYABLE_APPROVAL)) {
      throw redirect({
        to: "/app/accounting/payable-approvals",
        search: payableApprovalsSearchParamsSchema.parse({}),
      })
    }

    if (permissions.includes(PermissionActionType.PAY_FILE)) {
      throw redirect({
        to: "/app/accounting/huntington-pay-files",
        search: payFileSearchParamsSchema.parse({}),
      })
    }
  },
  component: () => <PermissionDeniedAlert />,
})
